import { Component, HostListener, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../environments/environment';
import { AccessControlService } from '../services/access-control/access-control.service';

@Component({
    selector: 'app-base-layout',
    imports: [
        MatToolbarModule,
        RouterModule,
        MatButton,
        MatMenuModule,
        MatIconModule,
    ],
    templateUrl: './base-layout.component.html',
    styleUrl: './base-layout.component.css'
})
export class BaseLayoutComponent implements OnInit {
  isDevEnvironment = !environment.production;

  constructor(private router: Router, public accessControl: AccessControlService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === '/') {
          this.scrollToTop();
        }
      }
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  navigateHome() {
    if (this.router.url === '/') {
      this.scrollToTop();
    } else {
      this.router.navigate(['/']);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const header = document.querySelector('.header') as HTMLElement;
      if (window.scrollY > 50) {
        // Adjust the scroll position as needed
        header.classList.add('transparent');
      } else {
        header.classList.remove('transparent');
      }
    }
  }

  ngOnInit(): void {
    this.onWindowScroll(); 
  }
}
